import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

/**
 * `body` の直下へ `createPortal` で出す。認証チェック中に `AppShell` の children として
 * 描画される経路があり、その本文ラッパーは登場アニメーション後も `transform: translateY(0)`
 * を残すため `position: fixed` の包含ブロックになる。木の中に置いたままだと全画面を覆えない。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 全画面ローディングスクリーン。認証チェック中・初期データ読み込み中にスピナーとステータスメッセージを全画面表示
 * @graph-connects none
 */
export function LoadingScreen() {
  const { t } = useTranslation();

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-[var(--color-bg-base)]">
      <div className="flex flex-col items-center gap-4">
        <div className="loading-spinner loading-spinner-lg" />
        <p className="text-[var(--color-text-muted)] text-sm">{t('status.loading')}</p>
      </div>
    </div>,
    document.body,
  );
}
